var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',{staticClass:"item",attrs:{"variant":"gradient"}},[(_vm.description)?_c('AppTitle',{domProps:{"textContent":_vm._s(_vm.description)}}):_vm._e(),(_vm.name)?_c('b',{domProps:{"textContent":_vm._s(_vm.name)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }